import { formatPercent } from '@common';

type CalculateSoldPercentArgsType = {
  ticketsSold: number;
  sellable: number;
};

export const calculateSoldPercent = ({
  ticketsSold,
  sellable,
}: CalculateSoldPercentArgsType): string | null => {
  if (sellable === 0) {
    return null;
  }

  return formatPercent((ticketsSold / sellable) * 100);
};
